import { BillingPlanFeature, useEnabledFeature } from 'resources/Organization/Features';
import { AmplitudeFlagKeys } from 'types/amplitudeFlags';

import useIsExperimentActive from 'components/Amplitude/useIsExperimentActive';

export const useConsumerFinancingFeatureEnabled = () => {
  const consumerFinancingBillingFeatureEnabled = useEnabledFeature(BillingPlanFeature.FEATURE_CONSUMER_FINANCING);
  const consumerFinancingExperimentEnabled = useIsExperimentActive(AmplitudeFlagKeys.consumerFinancing);

  return consumerFinancingBillingFeatureEnabled && consumerFinancingExperimentEnabled;
};
